import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const res = await axios.get(`${API_URL}/externalUsers`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, externalUserId) {
      const res = await axios.get(`${API_URL}/externalUsers/${externalUserId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, externalUserData) {
      const res = await axios.post(`${API_URL}/externalUsers`, externalUserData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { externalUserId, externalUserData }) {
      const res = await axios.put(`${API_URL}/externalUsers/${externalUserId}`, externalUserData);

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async remove(_, externalUserId) {
      const res = await axios.delete(`${API_URL}/externalUsers/${externalUserId}`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async activate(_, externalUserId) {
      const res = await axios.post(`${API_URL}/externalUsers/${externalUserId}/activate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async deactivate(_, externalUserId) {
      const res = await axios.post(`${API_URL}/externalUsers/${externalUserId}/deactivate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
